// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documitra-member-collapse .ant-collapse-header {
  display: flex !important;
  align-items: center !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  padding-right: 48px !important;
}
.documitra-member-collapse .ant-collapse-header-text {
  flex: 1 1;
  display: flex;
  align-items: center;
  min-width: 0;
}
.documitra-member-collapse .ant-collapse-arrow {
  top: 50% !important;
  right: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transform: translateY(-50%) !important;
}

.document-reminder-history-collapse .ant-collapse-header {
  align-items: center !important;
}
.document-reminder-history-collapse .ant-collapse-expand-icon,
.document-reminder-history-collapse .ant-collapse-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
}

.member-note-content {
  margin-top: 10px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}
.member-note-content .ql-toolbar {
  display: none;
}
.member-note-content .ql-container {
  border: none;
  font-size: 14px;
}
.member-note-content .ql-editor {
  padding: 0;
  word-break: break-word;
  cursor: default;
}

.member-note-editor {
  margin-bottom: 20px;
  padding: 16px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #f8fbff;
}
.member-note-editor .ql-toolbar.ql-snow,
.member-note-editor .ql-container.ql-snow {
  border-color: #cbd5e1;
}
.member-note-editor .ql-toolbar.ql-snow + .ql-container.ql-snow {
  min-height: 115px;
}

.member-note-field {
  margin-bottom: 12px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
}
.member-note-field:last-child {
  margin-bottom: 0;
}

.member-note-field-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.member-note-field-label {
  display: block;
  color: #0f172a;
  font-size: 14px;
}

.member-note-meta {
  display: block;
  margin-top: 3px;
  font-size: 12px;
}

.member-note-actions {
  margin-top: 12px;
}

.document-reminder-panel {
  border: 1px solid #dbe7f3;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 4px 14px rgba(30, 64, 175, 0.06);
}

.document-reminder-field {
  min-width: 0;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
}

.document-reminder-field .ant-typography {
  color: #334155;
  font-size: 13px;
}

.document-reminder-control.ant-input,
.document-reminder-control.ant-select .ant-select-selector {
  min-height: 40px;
  border-color: #cbd5e1;
  border-radius: 8px !important;
  box-shadow: none;
}

.document-reminder-control.ant-input:hover,
.document-reminder-control.ant-input:focus,
.document-reminder-control.ant-select:hover .ant-select-selector,
.document-reminder-control.ant-select-focused .ant-select-selector {
  border-color: #6495d1;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.08);
}

.floating-field {
  position: relative;
  width: 210px;
}

.floating-field input {
  width: 100%;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 0;
  outline: none;
  font-size: 15px;
  color: #000;
  box-sizing: border-box;
  background: #fff;
  transition: border-color 0.2s ease;
}

.floating-field select {
  width: 100%;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 0;
  outline: none;
  font-size: 15px;
  color: #000;
  box-sizing: border-box;
  background: #fff;
  transition: border-color 0.2s ease;
}

.floating-field input:focus,
.floating-field select:focus {
  border-color: #004195;
}

.floating-field label {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0 4px;
  background: #fff;
  color: #64748b;
  font-size: 15px;
  pointer-events: none;
  transition: all 0.2s ease;
}

/* Move label to border when focused */
.floating-field input:focus + label {
  top: 0;
  transform: translateY(-50%);
  font-size: 12px;
  color: #004195;
}

.floating-field select:focus + label {
  top: 0;
  transform: translateY(-50%);
  font-size: 12px;
  color: #004195;
}

/* Keep labels floated consistently so they do not overlap input content. */
.floating-field input + label {
  top: 0;
  transform: translateY(-50%);
  font-size: 11px;
  color: #64748b;
}

.floating-field select + label {
  top: 0;
  transform: translateY(-50%);
  font-size: 11px;
  color: #64748b;
}`, "",{"version":3,"sources":["webpack://./src/components/ReviewDocumitraOrder.scss"],"names":[],"mappings":"AACE;EACE,wBAAA;EACA,8BAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;AAAJ;AAGE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAIE;EACE,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,sCAAA;AAFJ;;AAOE;EACE,8BAAA;AAJJ;AAOE;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;AALJ;;AASA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AANF;AAQE;EACE,aAAA;AANJ;AASE;EACE,YAAA;EACA,eAAA;AAPJ;AAUE;EACE,UAAA;EACA,sBAAA;EACA,eAAA;AARJ;;AAYA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AATF;AAWE;;EAEE,qBAAA;AATJ;AAYE;EACE,iBAAA;AAVJ;;AAcA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAXF;AAaE;EACE,gBAAA;AAXJ;;AAeA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AAZF;;AAeA;EACE,cAAA;EACA,cAAA;EACA,eAAA;AAZF;;AAeA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAZF;;AAeA;EACE,gBAAA;AAZF;;AAeA;EACE,yBAAA;EACA,mBAAA;EACA,6DAAA;EACA,8CAAA;AAZF;;AAeA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAZF;;AAeA;EACE,cAAA;EACA,eAAA;AAZF;;AAeA;;EAEE,gBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;AAZF;;AAeA;;;;EAIE,qBAAA;EACA,6CAAA;AAZF;;AAsBA;EACE,kBAAA;EACA,YAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,kCAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,kCAAA;AAnBF;;AAsBA;;EAEE,qBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;AAnBF;;AAsBA,sCAAA;AACA;EACE,MAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,MAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;AAnBF;;AAsBA,2EAAA;AACA;EACE,MAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,MAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;AAnBF","sourcesContent":[".documitra-member-collapse {\n  .ant-collapse-header {\n    display: flex !important;\n    align-items: center !important;\n    padding-top: 10px !important;\n    padding-bottom: 10px !important;\n    padding-right: 48px !important;\n  }\n\n  .ant-collapse-header-text {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    min-width: 0;\n  }\n\n  .ant-collapse-arrow {\n    top: 50% !important;\n    right: 16px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    transform: translateY(-50%) !important;\n  }\n}\n\n.document-reminder-history-collapse {\n  .ant-collapse-header {\n    align-items: center !important;\n  }\n\n  .ant-collapse-expand-icon,\n  .ant-collapse-arrow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.member-note-content {\n  margin-top: 10px;\n  padding: 12px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n\n  .ql-toolbar {\n    display: none;\n  }\n\n  .ql-container {\n    border: none;\n    font-size: 14px;\n  }\n\n  .ql-editor {\n    padding: 0;\n    word-break: break-word;\n    cursor: default;\n  }\n}\n\n.member-note-editor {\n  margin-bottom: 20px;\n  padding: 16px;\n  border: 1px solid #dbeafe;\n  border-radius: 10px;\n  background: #f8fbff;\n\n  .ql-toolbar.ql-snow,\n  .ql-container.ql-snow {\n    border-color: #cbd5e1;\n  }\n\n  .ql-toolbar.ql-snow + .ql-container.ql-snow {\n    min-height: 115px;\n  }\n}\n\n.member-note-field {\n  margin-bottom: 12px;\n  padding: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.member-note-field-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.member-note-field-label {\n  display: block;\n  color: #0f172a;\n  font-size: 14px;\n}\n\n.member-note-meta {\n  display: block;\n  margin-top: 3px;\n  font-size: 12px;\n}\n\n.member-note-actions {\n  margin-top: 12px;\n}\n\n.document-reminder-panel {\n  border: 1px solid #dbe7f3;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);\n  box-shadow: 0 4px 14px rgba(30, 64, 175, 0.06);\n}\n\n.document-reminder-field {\n  min-width: 0;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #ffffff;\n}\n\n.document-reminder-field .ant-typography {\n  color: #334155;\n  font-size: 13px;\n}\n\n.document-reminder-control.ant-input,\n.document-reminder-control.ant-select .ant-select-selector {\n  min-height: 40px;\n  border-color: #cbd5e1;\n  border-radius: 8px !important;\n  box-shadow: none;\n}\n\n.document-reminder-control.ant-input:hover,\n.document-reminder-control.ant-input:focus,\n.document-reminder-control.ant-select:hover .ant-select-selector,\n.document-reminder-control.ant-select-focused .ant-select-selector {\n  border-color: #6495d1;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.08);\n}\n\n\n\n\n\n\n\n\n.floating-field {\n  position: relative;\n  width: 210px;\n}\n\n.floating-field input {\n  width: 100%;\n  height: 32px;\n  padding: 0 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 0;\n  outline: none;\n  font-size: 15px;\n  color: #000;\n  box-sizing: border-box;\n  background: #fff;\n  transition: border-color 0.2s ease;\n}\n\n.floating-field select {\n  width: 100%;\n  height: 32px;\n  padding: 0 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 0;\n  outline: none;\n  font-size: 15px;\n  color: #000;\n  box-sizing: border-box;\n  background: #fff;\n  transition: border-color 0.2s ease;\n}\n\n.floating-field input:focus,\n.floating-field select:focus {\n  border-color: #004195;\n}\n\n.floating-field label {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 0 4px;\n  background: #fff;\n  color: #64748b;\n  font-size: 15px;\n  pointer-events: none;\n  transition: all 0.2s ease;\n}\n\n/* Move label to border when focused */\n.floating-field input:focus + label {\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 12px;\n  color: #004195;\n}\n\n.floating-field select:focus + label {\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 12px;\n  color: #004195;\n}\n\n/* Keep labels floated consistently so they do not overlap input content. */\n.floating-field input + label {\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 11px;\n  color: #64748b;\n}\n\n.floating-field select + label {\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 11px;\n  color: #64748b;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
